import React, { useState, useRef } from "react";
import { Mensaje } from "../mensajes";
import { Dimmer } from "../spinner";
import useTable from "../useTable";
import axios from "axios";
import { ActualizarTipopro } from "./modalActualizarTipopro";
import { Toasts } from "../toasts";
import { SearchInput } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";
import Modal from "react-bootstrap/Modal";

const headCells = [
  {
    id: "idtipoproducto",
    label: "CODIGO",
    width: "80px",
    textAlign: "rifht",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "descripcion",
    label: "DESCRIPCION",
    width: "440px",
    textAlign: "left",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "accion",
    label: "OPCIONES",
    width: "180px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

function TablaTipopro(props) {
  const afiliado = JSON.parse(localStorage.getItem("riforganizacion"));
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const permiso = JSON.parse(localStorage.getItem("acctipoproducto"));
  const txtBuscador = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [tipopro, setTipopro] = useState();
  const [puc, setPuc] = useState();
  const [activate, setActivate] = useState(false);
  const [declaWeb] = useState(false);
  const [cuenta, setCuenta] = useState(false);
  const [idusuario] = useState(localStorage.getItem("idusuario"));
  const [ip] = useState(localStorage.getItem("ip"));
  const [idefiscal] = useState(localStorage.getItem("idefiscal"));
  const [mac] = useState(localStorage.getItem("mac"));
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [operacion, setOperacion] = useState(0);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idtipoproducto
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setTipopro();
  };

  const seleccionarRegistros = async () => {
    let campos = "*";
    let nomtab = "tipoproducto";
    let orden = "idtipoproducto";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          setActivate(false);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response);
        setMostrar(true);
        setActivate(false);
      })
      .finally(() => {
        txtBuscador.current?.focus();
      });
  };

  const seleccionarRegistro = (idtipoproducto) => {
    let campos = "*";
    let nomtab = "tipoproducto";
    let nomid = "idtipoproducto";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idtipoproducto}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idtipoproducto > 0) {
            setTipopro(response.data);
            //  setActivate(false);
            seleccionarRegistroPucxProduct(response.data.idtipoproducto);
          }
        } else {
          setActivate(false);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar5(true);
        setActivate(false);
      });
  };

  const seleccionarRegistroPucxProduct = (idtipoproducto) => {
    let campos = "*";
    let nomtab = "pucxtipoproducto";
    let nomid = "idtipoproducto";
    let nomid2 = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&id=${idtipoproducto}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${idefiscal}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            if (parseInt(response.data[0].idpuc) > 0) {
              seleccionarRegistroPuc(response.data[0].idpuc);
            }
            // } else {
            //   setTitulo("Notificacion");
            //   setMsg("El Clasificador Presupuestario no existe");
            //   setMostrar(true);
          }
          seleccionarRegistroCtaxProduct(idtipoproducto);
          setMostrar5(true);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar5(true);
        setActivate(false);
      });
  };

  const seleccionarRegistroCtaxProduct = (idtipoproducto) => {
    let campos = "*";
    let nomtab = "cuentacontablextipoproducto";
    let nomid = "idtipoproducto";
    let nomid2 = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&id=${idtipoproducto}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${idefiscal}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            if (parseInt(response.data[0].idcuentacontable) > 0) {
              seleccionarCuenta(
                response.data[0].idcuentacontable,
                response.data[0].idefiscal,
              );
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar5(true);
        setActivate(false);
      });
  };

  const seleccionarRegistroPuc = (idpuc) => {
    let campos = "*";
    let nomtab = "puc";
    let nomid = "idpuc";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idpuc}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idpuc > 0) {
            setPuc(response.data);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar5(true);
        setActivate(false);
      });
  };

  const seleccionarCuenta = (idcuentacontable) => {
    let endpoint = `${op.conexion}/api/comprasAlmacen/selectcuenta?id=${idcuentacontable}&efi=${idefiscal}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.cargar) {
            setCuenta(response.data);
            setMostrar5(true);
          } else {
            setTitulo("Notificacion");
            setMsg("LA CUENTA ES NO CARGABLE");
            setMostrar(true);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setActivate(false);
      });
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const cerrarMensaje = () => {
    setMostrar(false);

    if (
      msg === "El Clasificador Presupuestario no existe" ||
      "LA CUENTA ES NO CARGABLE"
    ) {
      setMostrar5(true);
    }
  };

  const consultarTipopro = (ope, id, per) => (event) => {
    event.preventDefault();
    blanquear();
    if (per.toString() === "1") {
      if (ope === 1) {
        setMostrar5(true);
        setOperacion(1);
      } else if (ope === 4) {
        setOperacion(4);
        seleccionarRegistro(id);
      } else if (ope === 2) {
        setOperacion(2);
        seleccionarRegistro(id);
      } else if (ope === 3) {
        setOperacion(3);
        seleccionarRegistro(id);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          ope === 1
            ? "No posee permiso para Registrar"
            : ope === 2
              ? "No posee permiso para Editar"
              : ope === 3
                ? "No posee permiso para Eliminar"
                : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };

  // useEffect(() => {
  //   seleccionarRegistros();
  // }, []);

  const cerrar = () => {
    blanquear();
    if (props.onHideCancelar) props.onHideCancelar();
    if (props.setShow) props.setShow(false);
    props.cerrar();
  };
  const cerrarModal = () => {
    if (props.onHideCancelar) {
      props.onHideCancelar();
    }
    if (props.setShow) props.setShow(false);

    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.cerrar();
  };
  const imprimir = () => {
    window.open(
      `${op.reportes}/comprasyalmacen?afiliado=${afiliado}&reporte=ListTipoProducto`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
        txtBuscador.current?.focus();
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>Gestion de Tipos de Productos.</h3>
        <a type="button" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={activate} inverted></Dimmer>
      <div className="col-12">
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
          <div className="col-4 m-0 p-0">
            <div className="w-100 m-0 p-0 input-group input-group-sm text-uppercase">
              <input
                type={"text"}
                className="form-control text-uppercase"
                onChange={handleSearch}
                placeholder="Buscar Tipo de Producto"
                ref={txtBuscador}
              />
              <button className="btn btn-sm btn-info" onClick={imprimir}>
                <i className="fas fa-print m-0" />
              </button>
            </div>
          </div>
          <div className="col-auto m-0 p-0">
            <PrimaryButton
              className="btn btn-sm btn-info"
              icon="fa-plus m-0"
              onClick={consultarTipopro(
                1,
                "",
                permiso.toString().substring(1, 2),
              )}
              disabled={permiso.toString().substring(1, 2) !== "1"}
            />
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={item.idtipoproducto} style={{ padding: "0" }}>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "10px",
                      }}
                    >
                      {item.idtipoproducto}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.descripcion}
                    </td>
                    <td
                      className="mx-auto"
                      align="center"
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "120px",
                      }}
                    >
                      <button
                        onClick={consultarTipopro(
                          4,
                          item.idtipoproducto,
                          permiso.toString().substring(0, 1),
                        )}
                        className={
                          permiso.toString().substring(0, 1) === "1"
                            ? "btn btn-sm btn-info rounded-circle"
                            : "btn btn-sm btn-secondary rounded-circle"
                        }
                      >
                        <i className="fas fa-eye"></i>
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={consultarTipopro(
                          2,
                          item.idtipoproducto,
                          permiso.toString().substring(2, 3),
                        )}
                        className={
                          permiso.toString().substring(2, 3) === "1"
                            ? "btn btn-sm btn-warning rounded-circle"
                            : "btn btn-sm btn-secondary rounded-circle"
                        }
                      >
                        <i className="fa fa-edit"></i>
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={consultarTipopro(
                          3,
                          item.idtipoproducto,
                          permiso.toString().substring(3, 4),
                        )}
                        className={
                          permiso.toString().substring(3, 4) === "1"
                            ? "btn btn-sm btn-danger rounded-circle"
                            : "btn btn-sm btn-secondary rounded-circle"
                        }
                      >
                        <i className="fa fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
        <ActualizarTipopro
          show={mostrar5}
          declaWeb={declaWeb}
          ip={ip}
          mac={mac}
          idusuario={idusuario}
          tipopro={tipopro}
          puc={puc}
          cuenta={cuenta}
          operacion={operacion}
          onHideRenderizar={seleccionarRegistros}
          onHideCancela={cerrarModalActualizar}
        />

        <Dimmer active={activate} inverted></Dimmer>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={cerrarMensaje}
        />

        <Toasts
          show={toast.mostrar}
          titulo={toast.titulo}
          mensaje={toast.mensaje}
          onHideCancela={cerrarToast}
        />
      </div>
    </Modal>
  );
}

export default TablaTipopro;
